/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMSignUpPayload } from '@/data/types/GTM';

export const getGTMSignUpEventData = async (payload: GTMSignUpPayload) => ({
	method: payload.method,
	form_name: payload.form_name,
	// settings: payload.settings,
	form_origin: payload.origin,
	login_origin: payload.login_origin,
});
